export const SELECCION = 'S';
